






























import { Vue, Component } from "vue-property-decorator";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import ContractorItem from "@/components/contractors/ContractorItem.vue";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import { getCurrentEmployee, isRoot } from "@/plugins/roles";

@Component({
  components: { CBreadCrumbs, ContractorItem }
})
export default class ContractorItemView extends Vue {
  contractor!: IContractorNew;
  data() {
    return {
      contractor: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "contractorList" },
        label: this.$tc(this.$translate.Contractors)
      },
      {
        label: this.contractor.email
          ? this.$converter.limitedOutput(this.contractor.email, 40)
          : this.$tc(this.$translate.Contractor)
      }
    ];
  }

  get root() {
    return isRoot();
  }

  get isEmployee() {
    return !!getCurrentEmployee();
  }

  getContractor() {
    api.ContractorApi.getContractorNew(this.$route.params.contractorId)
      .then((res: { data: IContractorNew }) => {
        this.contractor = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getContractor();
  }
}
